export default "__VITE_ASSET__C0B2zFC8__"